<template>
  <div id="app">
		<Navbar/>
    <router-view id="routerView"/>
		<Footer/>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar"
import Footer from "@/components/Footer"

export default{
  name: 'App', 
  components: {
    Navbar, 
    Footer
  }, 
  methods: {}
};
</script>
